import { render } from "./CardNoPadding.vue?vue&type=template&id=10aa4650"
import script from "./CardNoPadding.vue?vue&type=script&lang=js"
export * from "./CardNoPadding.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__